/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAuthInfo } from '../fn/auth/get-auth-info';
import { GetAuthInfo$Params } from '../fn/auth/get-auth-info';
import { VcoAuthenticatedUserWithSummaryDto } from '../models/vco-authenticated-user-with-summary-dto';

@Injectable({ providedIn: 'root' })
export class AuthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAuthInfo()` */
  static readonly GetAuthInfoPath = '/auth';

  /**
   * Get authentication information.
   *
   * Links the caller to the organization named in their token, then returns the caller's information and all permissions within a single object
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuthInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthInfo$Response(params?: GetAuthInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<VcoAuthenticatedUserWithSummaryDto>> {
    const obs = getAuthInfo(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get authentication information.
   *
   * Links the caller to the organization named in their token, then returns the caller's information and all permissions within a single object
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuthInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthInfo(params?: GetAuthInfo$Params, context?: HttpContext): Observable<VcoAuthenticatedUserWithSummaryDto> {
    const resp = this.getAuthInfo$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VcoAuthenticatedUserWithSummaryDto>): VcoAuthenticatedUserWithSummaryDto => r.body)
    );
  }

}
